import ListChecked16 from '@carbon/icons-react/es/list--checked/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { PanelHeaderTitle } from 'components/atoms/collapse';
import { IconShell } from 'components/atoms/icon-shell';

export const SubTasksTitle: FC<{ noOfItems?: number | undefined }> = ({
  noOfItems,
}) => (
  <PanelHeaderTitle
    icon={<IconShell icon={<ListChecked16 />} />}
    title={
      <span data-cy="sub_tasks.title">
        <FormattedMessage id="sub_tasks" />
      </span>
    }
    noOfItems={noOfItems}
  />
);
